import { cn } from '@/lib/cn';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export type SpinnerTone = 'yellow' | 'purple' | 'white';

interface LoadingSpinnerProps {
  size?: SpinnerSize;
  tone?: SpinnerTone;
  className?: string;
  /** Accessible label — defaults to "Carregando" */
  label?: string;
}

const sizeStyles: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-[3px]',
  lg: 'h-10 w-10 border-4',
};

const toneStyles: Record<SpinnerTone, string> = {
  yellow: 'border-brand-yellow/20 border-t-brand-yellow',
  purple: 'border-brand-purple/20 border-t-brand-purple',
  white: 'border-white/30 border-t-white',
};

/**
 * Branded spinner (spinning ring). Use for async form submits and
 * data-dependent page regions. Respects prefers-reduced-motion via
 * the global override in globals.css.
 */
export function LoadingSpinner({
  size = 'md',
  tone = 'yellow',
  className,
  label = 'Carregando',
}: LoadingSpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        'inline-block rounded-full animate-spin',
        sizeStyles[size],
        toneStyles[tone],
        className
      )}
    >
      <span className="sr-only">{label}…</span>
    </span>
  );
}
